// extracted by mini-css-extract-plugin
module.exports = {"comment":"CommentCard_comment__1omsT"};